// utils
import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {

    getAddressBooks: "/address_book/search",
    //
    addAddressBook: "/address_book/create",
    deleteAddressBook: "/address_book/delete",
    editAddressBook: "/address_book/edit",
    markAddressBookAsDefault: "/address_book/set_default"
};

// ----------------------------------------------------------------------




const getAddressBooks = (request) => axios.get(`${ API_ENDPOINTS.getAddressBooks }`, {
    params: {
        ...request
    }
});

const addAddressBook = (request) => axios.post(`${ API_ENDPOINTS.addAddressBook }`, { ...request });

const deleteAddressBook = (id) => axios.post(`${ API_ENDPOINTS.deleteAddressBook }`, { id });

const editAddressBook = (request) => axios.post(`${ API_ENDPOINTS.editAddressBook }`, { ...request });

const markAddressBookAsDefault = (request) => axios.post(`${ API_ENDPOINTS.markAddressBookAsDefault }`, { ...request });

// ----------------------------------------------------------------------

export {
    //
    getAddressBooks as getAddressBooksAPI,
    //
    addAddressBook as addAddressBookAPI,
    deleteAddressBook as deleteAddressBookAPI,
    editAddressBook as editAddressBookAPI,
    //
    markAddressBookAsDefault as markAddressBookAsDefaultAPI
};
